export const CONFIG = {
    IS_AJAX: false,
    IS_LAZY_LOADING: true,
    DEBUG: DEV
};



// WEBPACK FOOTER //
// ./src/js/consts.js